// MirtaPBX Call Linking — shared constants.
// Single named sources for polling intervals, the dial-mode storage key/default,
// and the feature's route paths. Referenced by the live-call banner, the unlinked
// badge, the call button, and the router so these values are never duplicated.

/** Dial-mode preference values: desk phone / MirtaPBX app vs. browser softphone. */
export type DialMode = "click_to_call" | "webrtc";

/** Extension-state poll interval (ms) used by the Live Call Banner. QA-tunable. */
export const LIVE_CALL_POLL_MS = 2500;

/** Optional in-banner call-context poll interval (ms). */
export const CALL_CONTEXT_POLL_MS = 3000;

/** Upper bound (ms) after which live-call polling stops. */
export const CALL_CONTEXT_TIMEOUT_MS = 120000;

/** Unlinked-calls header badge poll interval (ms). */
export const UNLINKED_BADGE_POLL_MS = 60000;

/** Local-storage key holding the user's persisted dial-mode preference. */
export const DIAL_MODE_STORAGE_KEY = "telephony.dialMode";

/** Dial mode used when no preference has been stored yet. */
export const DEFAULT_DIAL_MODE: DialMode = "click_to_call";

/** Route path for the Unlinked Calls inbox. */
export const ROUTE_UNLINKED_CALLS = "/mirtapbx/unlinked";

/** Route path for the admin User-Extensions mapping screen. */
export const ROUTE_USER_EXTENSIONS = "/settings/telephony/user-extensions";
